"use strict";

import {onFind} from "@elements/init-modules-in-scope";
import {addClass, closest, on, removeClass, findAllIn, findIn, find} from "@elements/dom-utils";
import asyncAppend from "@elements/async-append";
import fetch from '@elements/fetch';

const selectors = {
    button: '.js-step-form-extended__button',
    wrapper: '.js-step-form-extended',
    loading: '.js-step-form-extended__loading',
    result: '.js-step-form-extended__result',
};

export function init() {
    onFind(selectors.wrapper, function (baseElement) {
        let buttons = findAllIn(selectors.button, baseElement);
        buttons.forEach(function (button) {
            on('click', function () {
                let url = button.getAttribute('data-step-form-extended-url');
                console.log("CLICKED");
                asyncAppend({
                    target: findAllIn(selectors.result, baseElement),
                    loading: findAllIn(selectors.loading, baseElement)
                }, fetch(url));
            }, button);
        });
    })
}